export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileTerapia');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileTerapia');
    }
}
